let bound = false;

export function initAdminPanel(): void {
  if (bound) return;
  bound = true;

  const toggle = (head: HTMLElement) => {
    const card = head.closest<HTMLElement>("[data-admin-panel]");
    card?.classList.toggle("collapsed");
  };

  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement;
    // Header utility links (comments / hubspot) keep their own behavior.
    if (target.closest("a")) return;
    const head = target.closest<HTMLElement>("[data-admin-toggle]");
    if (head) toggle(head);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Enter" && e.key !== " ") return;
    const head = (e.target as HTMLElement).closest<HTMLElement>("[data-admin-toggle]");
    if (!head) return;
    e.preventDefault();
    toggle(head);
  });
}
